import Footer from "comps/Footer"
import Header from "comps/Header"
import Layout from "comps/Layout"
import imgH5403 from "images/error/403.png"
import imgH5403W from "images/error/403w"
import imgH5404 from "images/error/404.png"
import imgH5404W from "images/error/404w"
import imgH5500 from "images/error/500.png"
import imgH5500W from "images/error/500w"
import imgH5other from "images/error/czyc@2x.png"
import imgH5otherW from "images/error/czyc@2xw"
import imgPC403 from "images/error/pc-403.png"
import imgPC403W from "images/error/pc-403w"
import imgPC404 from "images/error/pc-404.png"
import imgPC404W from "images/error/pc-404w"
import imgPC500 from "images/error/pc-500.png"
import imgPC500W from "images/error/pc-500w"
import { DeviceContext, MediaQueryContext } from "libs/contexts"
import { webps } from "libs/imgs"
import { useContext } from "react"

webps[imgH5403] = imgH5403W
webps[imgH5404] = imgH5404W
webps[imgH5500] = imgH5500W
webps[imgH5other] = imgH5otherW
webps[imgPC403] = imgPC403W
webps[imgPC404] = imgPC404W
webps[imgPC500] = imgPC500W

export type ErrorViewProps = {
  statusCode: number
  url?: string
  message?: string
}

const ImgMap = {
  pc403: {
    src: imgPC403,
    width: 377,
    text: "抱歉，您无权访问该页面",
  },
  pc404: {
    src: imgPC404,
    width: 318,
    text: "抱歉，你访问的页面不存在哦～",
  },
  pc500: {
    src: imgPC500,
    width: 210,
    text: "抱歉，服务器出错了哦～",
  },
  h5404: {
    src: imgH5404,
    width: 160,
    text: <span>抱歉，你访问的页面不存在哦～</span>,
  },
  h5403: {
    src: imgH5403,
    width: 198,
    text: <span>抱歉，您无权访问该页面</span>,
  },
  h5500: {
    src: imgH5500,
    width: 111,
    text: <span>抱歉，服务器出错了哦～</span>,
  },
  h5other: {
    src: imgH5other,
    width: 146,
    text: "",
  },
}

export default function ErrorView({ statusCode, message, url }: ErrorViewProps) {
  const { isMobile } = useContext(MediaQueryContext) || {}
  if (isMobile) {
    return <H5Content statusCode={statusCode} message={message} />
  }
  return (
    <Layout
      header={<Header />}
      footer={<Footer />}
      title="出错了"
      keywords=""
      description=""
    >
      <ErrorPCContent statusCode={statusCode} message={message} url={url} />
    </Layout>
  )
}

export function ErrorPCContent({ statusCode, message, url }: ErrorViewProps) {
  const { buildImgSrc } = useContext(DeviceContext)

  // pc暂无其他异常
  const item = ImgMap[`pc${statusCode}`] || ImgMap.pc500
  const text = message || item.text
  return (
    <div className="container">
      <img src={buildImgSrc(item.src)} width={item.width} alt="出错了" />
      {url && <div className="err-path">{url}</div>}
      <div className="err-txt">{text}</div>

      <style jsx>{`
        .container {
          background-color: #efeff1;
          padding: 95px 0 80px;
        }

        .container img {
          display: block;
          height: auto;
          margin: 0 auto;
        }
        .err-txt {
          font-size: 18px;
          color: #6b778c;
          line-height: 1;
          text-align: center;
          margin-top: 16px;
        }
        .err-path {
          font-size: 14px;
          color: #ccc;
          margin-top: 12px;
          text-align: center;
        }
      `}</style>
    </div>
  )
}

function H5Content({ statusCode, message }: ErrorViewProps) {
  const { buildImgSrc } = useContext(DeviceContext)

  const item = ImgMap[`h5${statusCode}`] || ImgMap.h5other
  const text = message || item.text
  return (
    <div className="container">
      <img src={buildImgSrc(item.src)} width={item.width} alt="出错了" />
      <div className="text">{text}</div>
      <style jsx>{`
        .container {
          height: 100vh;
          display: flex;
          flex-direction: column;
          justify-content: center;
          background-color: #efeff1;
        }

        .container img {
          display: block;
          height: auto;
          margin: 0 auto;
        }
        .text {
          margin-top: 25px;
          padding: 0 10px;
          font-size: 15px;
          color: #8c8c8c;
          letter-spacing: -1px;
          text-align: center;
          line-height: 22px;
        }
      `}</style>
    </div>
  )
}
